import { AxiosError } from "axios";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import { CreateVoucher, Voucher } from "../types/Voucher";
import { GET_VOUCHERS_KEY } from "./useGetVouchers";
import { API, fetcher } from "@/shared/core-configs";
import { GET_PRODUCTS_FETCH_KEY } from "@/shared/core-products";

const createVoucher = async (data: CreateVoucher) => {
  const response = await fetcher.post(`${API.GESLUB_SERVICE}/voucher`, data);

  return response.data;
};

export const useCreateVoucher = () => {
  const queryClient = useQueryClient();

  const { mutateAsync, isPending, error, isError } = useMutation<
    Voucher,
    AxiosError<{ message: string }>,
    CreateVoucher
  >({
    mutationFn: createVoucher,
    onSuccess: async () => {
      await queryClient.invalidateQueries({ queryKey: [GET_VOUCHERS_KEY] });
      await queryClient.invalidateQueries({
        queryKey: [GET_PRODUCTS_FETCH_KEY],
      });
    },
  });

  return {
    createVoucher: mutateAsync,
    isPending,
    error,
    isError,
  };
};
